import React, { useState } from "react";
import { FaPhoneAlt, FaEnvelope, FaRegCopy, FaCheckCircle, FaMapMarkerAlt } from "react-icons/fa";
import "./Contact.css";

const Contact = () => {
  const phone = "+1 (940) 765 1594";
  const email = "info@thewedev.com";
  const address = "1404 Oak Tree Rd, Ste 214, Iselin, NJ 08830";

  const [copied, setCopied] = useState("");

  const copyText = async (text, key) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(key);
      setTimeout(() => setCopied(""), 1500);
    } catch (e) {
      // fallback: do nothing (clipboard may fail on some browsers without HTTPS)
    }
  };

  const sanitizedPhone = phone.replace(/\s|\(|\)|-/g, "");
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  return (
    <section id="contact" className="contact-section">
      <div className="contact-bg-blobs" aria-hidden="true">
        <span className="blob blob-1" />
        <span className="blob blob-2" />
        <span className="blob blob-3" />
      </div>

      <div className="contact-container">
        <div className="contact-shell">
          {/* Left Side */}
          <div className="contact-left" data-aos="fade-right">
            <p className="contact-pill">Contact</p>

            <h2 className="contact-heading">
              Let’s build something <span className="contact-highlight">remarkable</span>.
            </h2>

            <p className="contact-subtext">
              Have a project in mind or need help with design & development? Reach out 
              we respond fast and keep things simple.
            </p>

            <div className="contact-features">
              <div className="feature">
                <div className="feature-dot" />
                <span>Quick response (usually within 24 hours)</span>
              </div>
              <div className="feature">
                <div className="feature-dot" />
                <span>Pixel perfect UI with modern UX</span>
              </div>
              <div className="feature">
                <div className="feature-dot" />
                <span>Reliable delivery & long term support</span>
              </div>
            </div>

            <div className="contact-note">
              Prefer a quick call? Tap “Call Now” or copy our details in one click.
            </div>
          </div>

          {/* Right Side */}
          <div className="contact-right" data-aos="fade-left">
            {/* Call Card */}
            <div className="contact-card premium-card">
              <div className="contact-card-top">
                <div className="icon-chip">
                  <FaPhoneAlt />
                </div>
                <div className="contact-card-title">
                  <h3>Call Us</h3>
                  <p>Mon-Sat · 10am-7pm</p>
                </div>
              </div>

              <div className="contact-value-row">
                <a className="contact-value" href={`tel:${sanitizedPhone}`}>
                  {phone}
                </a>

                <button
                  className="copy-btn"
                  onClick={() => copyText(phone, "phone")}
                  aria-label="Copy phone number"
                  type="button"
                >
                  {copied === "phone" ? <FaCheckCircle /> : <FaRegCopy />}
                </button>
              </div>

              <a className="action-btn primary" href={`tel:${sanitizedPhone}`}>
                Call Now
              </a>
            </div>

            {/* Address Card (NEW: below Call Us) */}
            <div className="contact-card premium-card">
              <div className="contact-card-top">
                <div className="icon-chip">
                  <FaMapMarkerAlt />
                </div>
                <div className="contact-card-title">
                  <h3>Address</h3>
                  <p>Visit or mail us</p>
                </div>
              </div>

              <div className="contact-value-row">
                <a
                  className="contact-value address-value"
                  href={mapsUrl}
                  target="_blank"
                  rel="noreferrer"
                  title="Open in Google Maps"
                >
                  {address}
                </a>

                <button
                  className="copy-btn"
                  onClick={() => copyText(address, "address")}
                  aria-label="Copy address"
                  type="button"
                >
                  {copied === "address" ? <FaCheckCircle /> : <FaRegCopy />}
                </button>
              </div>

              <a className="action-btn" href={mapsUrl} target="_blank" rel="noreferrer">
                Open in Maps
              </a>
            </div>

            {/* Email Card */}
            <div className="contact-card premium-card">
              <div className="contact-card-top">
                <div className="icon-chip">
                  <FaEnvelope />
                </div>
                <div className="contact-card-title">
                  <h3>Email</h3>
                  <p>Best for project details</p>
                </div>
              </div>

              <div className="contact-value-row">
                <a className="contact-value" href={`mailto:${email}`}>
                  {email}
                </a>

                <button
                  className="copy-btn"
                  onClick={() => copyText(email, "email")}
                  aria-label="Copy email address"
                  type="button"
                >
                  {copied === "email" ? <FaCheckCircle /> : <FaRegCopy />}
                </button>
              </div>

              <a className="action-btn" href={`mailto:${email}`}>
                Send Email
              </a>
            </div>

            {copied && (
              <div className="toast" role="status" aria-live="polite">
                Copied{" "}
                {copied === "phone" ? "phone number" : copied === "email" ? "email" : "address"} ✅
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
